
export default function WorkTypeView() {

  let onChange = (e) => {

  }

  return {
    oninit: function (vnode) {
      if (vnode.attrs.onChange) {
        onChange = vnode.attrs.onChange
      }

    },
    oncreate: function (vnode) {


    },
    onupdate: function (vnode) {

    },
    view: (vnode) => {
      return [
        vnode.attrs.workType.map(wt =>
          [
            m('button[type="button"]',
              {
                "class": vnode.attrs.selectedWorkType == wt.code ? " btn btn-primary" : "btn btn-white",
                onclick: () => { onChange(wt.code) }
              }, wt.name)
          ]),
      ]
    }
  }
}
